/*! Dr. Weil - v0.1.0
 * http://drweil.com
 * Copyright (c) 2024; */
document.addEventListener('alpine:init', () => {
	Alpine.store('global', {
		isSticky: false,
		isSiteDrawerOpen: false,
		isSearchOpen: false,

		closeAll() {
			this.isSiteDrawerOpen = false;
			this.isSearchOpen = false;
		},

		toggleSiteDrawer() {
			this.isSiteDrawerOpen = !this.isSiteDrawerOpen;
			document.body.classList.toggle('menu-is-open', this.isSiteDrawerOpen);
		},

		toggleSiteSearch() {
			this.isSearchOpen = !this.isSearchOpen;
		},
	});
});

document.addEventListener('DOMContentLoaded', () => {
	const headerElement = document.getElementById('js-header');
	const headroom  = new Headroom(headerElement, {
      offset : 100,
      tolerance: 10,
    });
	headroom.init();
});

document.addEventListener('DOMContentLoaded', () => {

	/**
	 * Hero
	 */
	const heroEl = document.getElementById('js-hero');

	if (heroEl) {
		const heroSwiper = new Swiper(heroEl, {
			autoplay: {
				delay: 3000,
			},
			effect: 'fade',
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			loop: true,
			speed: 750,
			watchSlidesProgress: true,
			pagination: {
				el: heroEl.getElementsByClassName('swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: heroEl.getElementsByClassName('swiper-button-next')[0],
				prevEl: heroEl.getElementsByClassName('swiper-button-prev')[0],
			},
			breakpoints: {
				// 640: {},
				// 768: {},
				// 1024: {},
				// 1280: {},
				1536: {
					simulateTouch: false,
				},
				// 1780: {},
			},
		});
	}

	/**
	 * Featured Section Sub Items
	 */
	const fsbiEl = document.querySelectorAll('.featured-single-sub-items > .swiper');

	if (fsbiEl && fsbiEl.length > 0) {

		for (let i = 0; i < fsbiEl.length; i++) {

			let fsbiSwiper = new Swiper(fsbiEl[i], {
				keyboard: {
					enabled: true,
					onlyInViewport: true
				},
				slidesPerGroup: 3,
				slidesPerView: 3,
				speed: 200,
				watchSlidesProgress: true,
				pagination: {
					el: fsbiEl[i].getElementsByClassName('swiper-pagination')[0],
					clickable: true
				},
				navigation: {
					nextEl: fsbiEl[i].getElementsByClassName('swiper-button-next')[0],
					prevEl: fsbiEl[i].getElementsByClassName('swiper-button-prev')[0]
				},
				breakpoints: {
					0: {
						slidesPerGroup: 1,
						slidesPerView: 1
					},
					640: {
						slidesPerGroup: 2,
						slidesPerView: 2
					},
					// 768: {},
					// 1024: {},
					// 1280: {},
					1536: {
						simulateTouch: false
					}
					// 1780: {},
				}
			});
		}
	}
});

document.addEventListener('DOMContentLoaded', () => {
	AOS.init({
		duration: 600,
		easing: 'ease-out',
		once: true,
	});
});

svg4everybody();

(function( window ) {
	var filterBar = document.getElementById( 'js-filter-bar' ),
			filterButton = document.getElementById( 'recipe-filter' ),
			course = document.getElementById( 'course' ),
			ingredient = document.getElementById( 'ingredient' );

	function recipeRedirect( e ) {
		e.preventDefault();
		var path = '',
				recipesURL = weilRecipes.recipesURL;

		if ( course.value !== '-1' ) {
			path += '/course/' + course.value;
		}
		if ( ingredient.value !== '-1' ) {
			path += '/ingredient/' + ingredient.value;
		}

		window.location = recipesURL + path;

	}

	if ( filterBar ) {
		filterBar.addEventListener( 'submit', recipeRedirect );
	}
})( window );

(function( window ) {
	var askForm = document.getElementById( 'js-ask-weil-bar' ),
		askButton = document.getElementById( 'js-ask-weil-button' );

	if ( askForm ) {
		window.addEventListener( 'ask-weil-rendered', function() {
			askForm.addClass( 'rendered' );
		} );
	}
})( window );
var menuToggle = document.getElementById( 'js-menu-toggle' ),
	menu = document.getElementById( 'js-site-drawer' );

function closeMenu() {
	// Close the menu
	menu.setAttribute( 'aria-hidden', 'true' );
	menuToggle.setAttribute( 'aria-expanded', 'false' );

	// Bubble to the document
	document.body.classList.remove( 'menu-is-open' );

	// Focus back on menu toggle
	menuToggle.focus();
}

(function( window ) {
	var menuClose = document.getElementById( 'js-close-drawer' ),
			mobileMenuOverlay = document.getElementById( 'js-site-drawer-overlay' );

	// Small screens menu logic
	// ====================================================

	function openMenu() {
		// Open the menu
		menu.setAttribute( 'aria-hidden', 'false' );
		menuToggle.setAttribute( 'aria-expanded', 'true' );

		// Bubble to the document
		document.body.classList.add( 'menu-is-open' );

		// Set focus to the first link
		menu.querySelectorAll( 'a' )[0].focus();
	}


	function menuToggleHandle( e ) {
		// Stop links from firing
		e.preventDefault();

		if ( document.body.classList.contains( 'menu-is-open' ) ) {
			closeMenu();
		} else {
			openMenu();
			if ( /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream ) {
				window.scrollTo(0,0);
			}
		}
	}

	if ( menuToggle ) {
		menuToggle.addEventListener( 'click', menuToggleHandle );
		menuClose.addEventListener( 'click', closeMenu );

		if ( /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream ) {
			document.ontouchmove = function ( event ) {

				var isTouchMoveAllowed = true, target = event.target;

				while ( target !== null ) {
					if ( target.classList && target.classList.contains( 'menu-is-open' ) ) {
						isTouchMoveAllowed = false;
						break;
					}
					target = target.parentNode;
				}

				if ( !isTouchMoveAllowed ) {
					event.preventDefault();
				}

			};
		}
	}

	if ( mobileMenuOverlay ) {
		mobileMenuOverlay.addEventListener( 'click', closeMenu );
	}
})( window );

(function(window) {
	var menu = document.getElementById("js-site-drawer"),
		submenuClose = document.getElementById("js-close-submenu"),
		topLevelLinks = menu.querySelectorAll(".has-children > a"),
		topLevelLinksLength = topLevelLinks.length,
		menuCreated = false;

	// Small screens submenu logic
	// See menu-toggle.js for small screen top menu logic
	// ====================================================

	function closeSubmenu() {
		var openSubmenu = menu ? menu.querySelector(".has-megamenu-open, .has-submenu-open") : null;
		if (menu && openSubmenu) {
			menu.classList.remove("has-submenu-open");
			openSubmenu.classList.remove("has-megamenu-open");
			openSubmenu.setAttribute("aria-expanded", "false");
		}

		// Set focus to the top link
		openSubmenu.querySelectorAll("a")[0].focus();
	}

	function submenuHandler(e) {
		if (e.target && e.target.matches("li.has-children > a")) {
			var topLevelLi = e.target.parentNode;

			e.preventDefault();
			if (topLevelLi) {
				var open = topLevelLi.classList.contains("has-megamenu-open") || topLevelLi.classList.contains("has-submenu-open");
				if (open) {
					// Close submenu
					topLevelLi.classList.remove("has-megamenu-open");
					topLevelLi.setAttribute("aria-expanded", "false");
					menu.classList.remove("has-submenu-open");
					// Set focus to the top link
					topLevelLi.querySelectorAll("a")[0].focus();
				} else {
					// Open submenu
					topLevelLi.classList.add("has-megamenu-open");
					topLevelLi.setAttribute("aria-expanded", "true");
					menu.classList.add("has-submenu-open");
					// Set focus to the first link
					topLevelLi
						.querySelector(".header-megamenu, .header-top-submenu, .has-submenu-open")
						.querySelector("a")
						.focus();
				}
			}
		}
	}

	// Large screens menu logic
	// ====================================================

	// Enable keyboard navigation, tabbing through menu should display megamenus
	function topMenuFocusHandler(e) {
		e.target.parentNode.classList.add("focused");
		e.target.parentNode
			.querySelector(".header-megamenu, .header-top-submenu")
			.setAttribute("aria-hidden", "false");
	}

	// De-focusing on last megamenu link should hide the megamenu
	function topMenuBlurHandler(e) {
		e.target.offsetParent.parentNode.classList.remove("focused");
		e.target.offsetParent.parentNode
			.querySelector(".header-megamenu, .header-top-submenu")
			.setAttribute("aria-hidden", "true");
	}

	// On mouseenter and mouseleave, update megamenu aria-hidden
	function topMenuHoverHandler(e) {
		e.target.parentNode.classList.add("focused");
		e.target.parentNode
			.querySelector(".header-megamenu, .header-top-submenu")
			.setAttribute("aria-hidden", "false");
	}

	function topMenuHoveroutHandler(e) {
		e.target.parentNode.classList.remove("focused");
		e.target.parentNode
			.querySelector(".header-megamenu, .header-top-submenu")
			.setAttribute("aria-hidden", "true");
	}

	if (topLevelLinks) {
		for (var i = 0; i < topLevelLinksLength; i++) {
			var megamenu = topLevelLinks[i].parentNode.querySelector(
					".header-megamenu, .header-top-submenu"
				),
				megamenuLinks = topLevelLinks[i].parentNode.querySelectorAll("a"),
				megamenuLinksLength = megamenuLinks.length;

			//topLevelLinks[i].addEventListener("focus", topMenuFocusHandler);
			//topLevelLinks[i].addEventListener("mouseenter", topMenuHoverHandler);
			//topLevelLinks[i].addEventListener("mouseleave", topMenuHoveroutHandler);

			console.log("dw");

			topLevelLinks[i].classList.toggle("focused");

			if (megamenu) {
				megamenu.addEventListener("mouseenter", topMenuHoverHandler);
				megamenu.addEventListener("mouseleave", topMenuHoveroutHandler);
			}

			megamenuLinks[megamenuLinksLength - 1].addEventListener(
				"blur",
				topMenuBlurHandler
			);
		}
	}

	var headerTopMenu = document.getElementById("js-header-top-menu");
	var headerTopMenuLinks = headerTopMenu.querySelectorAll("a");
	var headerTopMenuLinksLength = headerTopMenuLinks.length;

	var header = document.getElementById("js-header"),
		innerHeader = document.getElementById("js-header-inner"),
		innerHeaderStyle = getComputedStyle(innerHeader),
		innerHeaderOuterHeight = innerHeader.offsetHeight,
		innerHeaderPaddingTop = parseInt(innerHeaderStyle.paddingTop, 10),
		stickyLeaderBoard = document.getElementById("leaderboard_sticky"),
		stickyLeaderBoardClose = document.getElementById(
			"js-leaderboard-sticky-close"
		),
		scrollObject = {
			x: 0,
			y: 0
		};

	function headerTopMenuTabOrderLarge() {
		for (var i = 0; i < headerTopMenuLinksLength; i++) {
			headerTopMenuLinks[i].setAttribute("tabindex", 2);
		}
	}

	function headerTopMenuTabOrderSmall() {
		for (var i = 0; i < headerTopMenuLinksLength; i++) {
			headerTopMenuLinks[i].removeAttribute("tabindex");
		}
	}

	// De-focusing from last menu on small screen should close menu
	headerTopMenuLinks[headerTopMenuLinksLength - 1].addEventListener(
		"blur",
		closeMenu
	);

	// Helper functions
	// ====================================================

	function getScreenSize(sizeString) {
		var size = window
			.getComputedStyle(document.body, ":before")
			.getPropertyValue("content");

		if (size && size.indexOf(sizeString) !== -1) {
			return true;
		}
	}

	// Attach or remove events for small screen menu
	// ====================================================

	function maybeAttachEvents(e) {
		if (getScreenSize("small") && !menuCreated) {
			if (menu) {
				menu.addEventListener("click", submenuHandler);
			}
			if (submenuClose) {
				submenuClose.addEventListener("click", closeSubmenu);
			}
			headerTopMenuTabOrderSmall();
			menuCreated = true;
		} else if (getScreenSize("large") && menuCreated) {
			if (menu) {
				menu.removeEventListener("click", submenuHandler);
			}
			if (submenuClose) {
				submenuClose.removeEventListener("click", closeSubmenu);
			}
		} else if (getScreenSize("large")) {
			headerTopMenuTabOrderLarge();
		}
	}

	window.addEventListener("load", maybeAttachEvents);
	window.addEventListener("resize", _.debounce(maybeAttachEvents, 100));

	window.addEventListener("load", initStickyFooterAd);

	function initStickyFooterAd() {
		var stickyLeaderBoard = document.getElementById(
			"leaderboard-sticky-footer"
		);
		var stickyLeaderBoardClose = document.getElementById(
			"js-leaderboard-sticky-close"
		);

		if (stickyLeaderBoard) {
			stickyLeaderBoard.classList.add("footer-sticky");
			stickyLeaderBoardClose.addEventListener("click", closeLeaderboardAd);
		}
	}

	function closeLeaderboardAd() {
		var stickyLeaderBoard = document.getElementById(
			"leaderboard-sticky-footer"
		);
		if (stickyLeaderBoard) {
			stickyLeaderBoard.classList.remove("footer-sticky");
			stickyLeaderBoard.classList.remove("footer-sticky-scrollup");
			stickyLeaderBoard.classList.add("no-restick");
		}
	}

	function maybeStickHeader(e) {
		// Mobile sticky leaderboard
		if (stickyLeaderBoard) {
			if (
				window.pageYOffset > innerHeaderPaddingTop &&
				window.pageYOffset > scrollObject.y
			) {
				stickyLeaderBoard.classList.add("header-sticky");
				stickyLeaderBoard.classList.remove("header-sticky-scrollup");
			} else if (
				window.pageYOffset > innerHeaderPaddingTop &&
				window.pageYOffset < scrollObject.y
			) {
				stickyLeaderBoard.classList.add("header-sticky-scrollup");
			} else {
				stickyLeaderBoard.classList.remove("header-sticky");
				stickyLeaderBoard.classList.remove("header-sticky-scrollup");
			}
		}

		// Show sticky header if we're scrolling *down* past the header
		if (header) {
			if (
				window.pageYOffset > innerHeaderPaddingTop &&
				window.pageYOffset > scrollObject.y
			) {
				header.classList.add("header-sticky");
				header.classList.remove("header-sticky-scrollup");
				if (!getScreenSize("small")) {
					//document.body.style.paddingTop = innerHeaderOuterHeight + 'px';
				}
			} else if (
				window.pageYOffset > innerHeaderPaddingTop &&
				window.pageYOffset < scrollObject.y
			) {
				// If we're scrolling *up* and we're still below the header
				header.classList.add("header-sticky-scrollup");
				header.classList.remove("header-sticky");
			} else if (window.pageYOffset <= innerHeaderPaddingTop) {
				// If we're above the header
				header.classList.remove("header-sticky");
				header.classList.remove("header-sticky-scrollup");
				if (!getScreenSize("small")) {
					//document.body.style.paddingTop = 0;
				}
			}
		}

		scrollObject = {
			x: window.pageXOffset,
			y: window.pageYOffset
		};
	}

	if (header) {
		window.onload = maybeStickHeader;
		window.addEventListener("scroll", _.throttle(maybeStickHeader, 50));
	}

	var top = document.getElementById("leaderboard_top");
	var bottom = document.getElementById("leaderboard_bottom");
	var side_1 = document.getElementById("sidebar_1");
	var side_2 = document.getElementById("sidebar_2");
	var googleAd = document.getElementById("google-content-ad");

	if (!displayAds) {
		// Apply hide class to all
		if (top) top.classList.add("hidden");
		if (bottom) bottom.classList.add("hidden");
		if (side_1) side_1.classList.add("hidden");
		if (side_2) side_2.classList.add("hidden");
		if (googleAd) googleAd.classList.add("hidden");
	} else {
		// Remove the hide class just to be safe
		if (top) top.classList.remove("hidden");
		if (bottom) bottom.classList.remove("hidden");
		if (side_1) side_1.classList.remove("hidden");
		if (side_2) side_2.classList.remove("hidden");
		if (googleAd) googleAd.classList.remove("hidden");
	}
})(window);

(function( window ) {
	var newsletterModalClose, newsletterModal, newsletterModalTimer, newsletterModalDelay, newsletterModalForm;

	function closeNewsletterModal( e ) {

		newsletterModal.setAttribute( 'aria-hidden', 'true' );
		newsletterModal.classList.remove( 'visible' );

		sessionStorage.setItem( 'weil-hide-newsletter', 'true' );

		newsletterModal.removeEventListener( 'keyup', closeNewsletterModalEsc );
	}

	function closeNewsletterModalEsc( e ) {
		if ( e.keyCode == 27 ) {
			closeNewsletterModal( e );
		}
	}

	function openNewsletterModal() {
		if ( ! sessionStorage.getItem( 'weil-hide-newsletter' ) ) {
			newsletterModal.setAttribute( 'aria-hidden', 'false' );
			newsletterModal.classList.add( 'visible' );

			if ( ! Modernizr.touchevents ) {
				newsletterModal.querySelector( 'input' ).focus();
			}

			newsletterModal.addEventListener( 'keyup', closeNewsletterModalEsc );
		}
	}

	function startNewsletterTimer() {
		newsletterModalClose = document.getElementById( 'js-close-newsletter-modal' );
		newsletterModalForm = document.getElementById( 'js-newsletter-modal-form' );
		newsletterModal = document.getElementById( 'js-newsletter-modal' );
		newsletterModalDelay = 45000;
		newsletterModalTimer = setTimeout( openNewsletterModal, newsletterModalDelay );

		if ( newsletterModalClose ) {
			newsletterModalClose.addEventListener( 'click', closeNewsletterModal );
			newsletterModalForm.addEventListener( 'submit', closeNewsletterModal );
		}
	}

	// window.onload = startNewsletterTimer;
})( window );

(function(window) {
	var breadcrumbs = document.getElementById('js-breadcrumb-list'),
		breadcrumbsOl,
		delta;

	if (breadcrumbs) {
		breadcrumbsOl = breadcrumbs.querySelector('ol');
		delta = parseInt(breadcrumbsOl.offsetWidth - breadcrumbs.offsetWidth, 10);

		breadcrumbs.scrollLeft = delta;
	}
})(window);

(function( window ) {
	var submenuToggle = document.getElementById( 'js-subnavigation-title' );
	var submenu = document.getElementById( 'js-subnavigation' );

	function submenuToggleHandler() {
		if ( submenu.classList.contains( 'show-menu' ) ) {
			submenu.classList.remove( 'show-menu' );
		} else {
			submenu.classList.add( 'show-menu' );
		}
	}

	if ( submenuToggle ) {
		submenuToggle.addEventListener( 'click', submenuToggleHandler );
	}
})( window );

(function(window) {
	var shareCounts = document.querySelectorAll(".share-count");

	var sum = function(a, b) {
		return a + b;
	};

	var addShareCount = function(element) {
		var url = element.attributes["data-permalink"].value;
		if (typeof addthis === "undefined") {
			return;
		}
		addthis.sharecounters.getShareCounts(
			{
				service: ["facebook", "pinterest", "linkedin"],
				countUrl: url
			},
			function(obj) {
				element.innerText = obj.map(totalShareCount).reduce(sum);
			}
		);
	};

	var totalShareCount = function(serviceShareCount) {
		return isNaN(serviceShareCount.count) ? 0 : serviceShareCount.count;
	};

	if (shareCounts.length) {
		for (var i = 0; i < shareCounts.length; ++i) {
			var item = shareCounts[i];
			addShareCount(item);
		}
	}
})(window);
